import ReactDOM from "react-dom";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toggleCapsulesPopup } from "../../store/slices/capsules-slice";
import Tabs from "~/components/Tabs/Tabs.jsx";
import CapsuleGrid from "~/components/CapsuleGrid/CapsuleGrid.jsx";
import ProgressBar from "~/components/ProgressBar/ProgressBar.jsx";
import SelectedCapsulesList from "~/components/SelectedCapsulesList/SelectedCapsulesList.jsx";
import "./CapsuleSelectionPopup.css";

const CapsuleSelectionPopup = ({ data, selectedCapsules, handleQuantityChange }) => {
  const [category, setCategory] = useState("All");

  const isVisible = useSelector((state) => state.capsules.isCapsulesPopupVisible);

  const dispatch = useDispatch();

  useEffect(() => {
    if (isVisible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isVisible]);

  if (!isVisible) return null;

  return ReactDOM.createPortal(
    <div className="popup-overlay">
      <div className="popup-content">
        <button className="close-button" onClick={() => dispatch(toggleCapsulesPopup())}>
          X
        </button>
        <h2>Pick Your Capsules</h2>

        <Tabs category={category} setCategory={setCategory} />

        <CapsuleGrid
          data={data}
          category={category}
          selectedCapsules={selectedCapsules}
          handleQuantityChange={handleQuantityChange}
        />

        <ProgressBar selectedCapsules={selectedCapsules} data={data} />

        <SelectedCapsulesList
          selectedCapsules={selectedCapsules}
          data={data}
          handleQuantityChange={handleQuantityChange}
          onClose={() => dispatch(toggleCapsulesPopup())}
        />
      </div>
    </div>,
    document.getElementById("custom-dynamic-box-popup-root")
  );
};

export default CapsuleSelectionPopup;
